import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SnackbarStore } from '@cardapio-online/core/snackbar/snackbar';

@Component({
  selector: 'lib-ui-snackbar-host',
  templateUrl: './ui-snackbar-host.component.html',
  styleUrl: './ui-snackbar-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSnackbarHostComponent {
  protected readonly snackbarStore = inject(SnackbarStore);

  protected dismiss(id: string): void {
    this.snackbarStore.dismiss(id);
  }
}
